module.exports = __webpack_public_path__ + "static/size_img_3-ba911bdfeb48c8ed15ac69bfc3d5f992.png";